import type { NavigationComponent } from './components/Navigation/types';
import type { SnackbarComponent } from './components/Snackbar/type';

// Define all the theme components here
export enum ThemeComponents {
  Navigation = 'navigation',
  Snackbar = 'snackbar',
}

// Define the type for the theme components (each key optional — runtime often sets only snackbar or only navigation)
export type ThemeComponentsType = Partial<{
  [ThemeComponents.Navigation]: NavigationComponent;
  [ThemeComponents.Snackbar]: SnackbarComponent;
}>;
